import { get, isEmpty } from 'lodash';
import { TranscriptTransformers } from 'lp-vue-components';

/**
 * Extracts participants from UMS data
 * @param data {Object} - eventData from UMS
 * @return {{}}
 */
export const getParticipants = data => get(data, 'changes[0].result.conversationDetails.participants', {});

/**
 * Transforms participants from UMS eventData into a map by ID
 * @param participants
 * @return {{userId, role}}
 */
export const transformParticipantsByIdRole = participants => Object.entries(participants).reduce(
  (acc, participant) => {
    const [role, idsArray] = participant;
    if (!isEmpty(idsArray)) {
      idsArray.forEach((id) => {
        acc[id] = {
          userId: id,
          role,
        };
      });
    }
    return acc;
  }, {});

/**
 * Extracts "message" from UMS data
 * @param data
 * @return {[*]}
 */
export const getLastContentEventNotification = (data) => {
  const message = get(data, 'changes[0].result.lastContentEventNotification');
  return [message];
};

export const UMSTranscriptTransformer = TranscriptTransformers.UMS;

export const INCATranscriptTransformer = TranscriptTransformers.INCA;
